// src/components/navigation/shared/ShopSelectorbar.tsx
import { useState } from 'react';
import { Building, ChevronDown, Check } from 'lucide-react';
import { Shop } from '@cabukaka/types';

interface ShopSelectorbarProps {
  availableShops: Shop[];
  activeShop: Shop | null;
  onChange: (shop: Shop) => void;
}

export default function ShopSelectorbar({ 
  activeShop, 
  availableShops, 
  onChange 
}: ShopSelectorbarProps) {
  const [isOpen, setIsOpen] = useState(false);

  if (availableShops.length === 0) {
    return null;
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-3 py-2 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors min-w-[200px]"
      >
        {activeShop?.logo ? (
          <img 
            src={activeShop.logo} 
            alt={activeShop.name}
            className="w-5 h-5 rounded-full object-cover"
          />
        ) : (
          <Building size={18} className="text-gray-500 flex-shrink-0" />
        )}
        <span className="text-sm font-medium truncate flex-1 text-left">
          {activeShop?.name || 'Sélectionner une shop'}
        </span>
        <ChevronDown size={16} className={`text-gray-500 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setIsOpen(false)} 
          />
          <div className="absolute left-0 right-0 top-full mt-1 z-50 bg-white rounded-lg shadow-lg border max-h-64 overflow-y-auto">
            {availableShops.map((shop: Shop) => (
              <button
                key={shop.id}
                onClick={() => {
                  onChange(shop);
                  setIsOpen(false);
                }}
                className="w-full flex items-center justify-between px-4 py-2 hover:bg-gray-50 transition-colors"
              >
                <div className="flex items-center gap-2">
                  {shop.logo ? (
                    <img 
                      src={shop.logo} 
                      alt={shop.name}
                      className="w-5 h-5 rounded-full object-cover"
                    />
                  ) : (
                    <Building size={14} className="text-gray-400" />
                  )}
                  <span className="text-sm">{shop.name}</span>
                </div>
                {activeShop?.id === shop.id && (
                  <Check size={16} className="text-green-600" />
                )}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}